<template>
  <div class="row">
    <div class="testContentContainer">
      <div class="multipleChoiceContiner">
        <div class="testContent">
          <div class="content">
            <h3 class="pageTitle pageTitle--question">{{ qDetails.question }}</h3>
            <ul>
              <li v-for="option in qDetails.options" :key="option.title" :class="{ currentSelected: questionAnswer == option.value }" @click="nextPage(option.value)">
                <label v-html="option.title"></label>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="container" style="max-width: 100%;">
        <div class="row">
          <progressCmp :prevLink="qDetails.prevLink"></progressCmp>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  props: ['qDetails', 'qNumber'],
  data() {
    return {
      questionAnswer: null,
      alreadyAnswered: null
    }
  },
  mounted () {
    this.questionAnswer = null
    
    this.alreadyAnswered = this.$store.getters.StoreQuestionData[this.qNumber]
    if (this.alreadyAnswered) {
      this.questionAnswer = this.alreadyAnswered
    }
  },
  methods: {
    nextPage (value) {
      var self = this
      this.questionAnswer = value

      setTimeout(function() {
        self.$store.dispatch('saveQuestionData', {question: self.qNumber, data: value})
        self.$router.push('/' + self.qDetails.nextLink)
      }, 300);
    }
  }
}
</script>